export function prepareAiReportHtml(html: string) {
  const document = new DOMParser().parseFromString(html, "text/html");

  // srcdoc наследует base URL родителя. Якоря должны вести в документ отчёта.
  document.querySelectorAll<HTMLAnchorElement | HTMLAreaElement>("a[href], area[href]").forEach((link) => {
    const href = link.getAttribute("href")?.trim();
    if (href?.startsWith("#")) link.setAttribute("href", `about:srcdoc${href}`);
  });

  return `<!DOCTYPE html>\n${document.documentElement.outerHTML}`;
}
